import { required } from '@shared/lib/validation/validateRequired/required';
import { ProfilePhotoEditFormKeys } from '../../../config/form-constants';
import { validateForm } from '@shared/lib/validation/validate/validate';
import { ProfilePhotoEditFormFields } from '../../../ui/profile-photo-edit/modal-edit-photo-profile/types';

export const validateEditProfilePhoto = (fields: ProfilePhotoEditFormFields) => {
    const { validateField, errors } = validateForm();
    validateField({
        name: ProfilePhotoEditFormKeys.Photo,
        message: required(
            fields[ProfilePhotoEditFormKeys.Photo]?.localFiles.length ||
                fields[ProfilePhotoEditFormKeys.Photo]?.uploadedFiles.length
        ),
    });
    return errors;
};
